import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import '../css/utility-nav.css';
import '../css/all.min.css';

const UtilityNav = () => {
  const data = useStaticQuery(graphql`
    {
      wpMenu(locations: {eq: UTILITY}) {
        count
        id
        databaseId
        name
        slug
        menuItems {
          nodes {
            id
            databaseId
            title
            url
            description
            label
            linkRelationship
            target
            parentId
            cssClasses
          }
        }
      }
      wp {
        acfOptionsContact {
          themeOptionsContact {
            phoneLink
            phoneText
          }
        }
      }
    }
  `)

  const { phoneLink, phoneText } = data.wp.acfOptionsContact.themeOptionsContact;
  return (
    <div className="utilityNav">
      {(data.wpMenu && data.wpMenu.menuItems && data.wpMenu.menuItems.nodes) &&
        data.wpMenu.menuItems.nodes.map(
          prop => {
            return (
              <a key={prop.id} href={prop.url}>
                {/* { prop.menuItemsUtilityNav.icon != 'none' &&
                  <span className={prop.menuItemsUtilityNav.icon} />
                } */}
                {prop.label}
              </a>

            )
          }
        )}
         <a href={'tel:'+phoneLink}>{phoneText}</a>
        {/* <a href={'tel:'+phoneLink}><span className="fas fa-phone-alt"></span>{phoneText}</a> */}
    </div>
  )
}

export default UtilityNav
